import { render, staticRenderFns } from "./ModalSearchHeader.vue?vue&type=template&id=621a9c12&"
import script from "./ModalSearchHeader.vue?vue&type=script&lang=ts&"
export * from "./ModalSearchHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports